// @ts-nocheck
import { createRouter, createWebHistory, type Router, type RouteRecordRaw } from 'vue-router'

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/login-standalone',
        name: 'login-standalone',
        component: () => import('/src/views/login/LoginStandalone.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: false,
            blankLayout: true
        }
    },
    {
        path: '/vip-upgrade-standalone',
        name: 'vip-upgrade-standalone',
        component: () => import('/src/views/svip/VipUpgradeStandalone.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: false,
            blankLayout: true
        }
    },
    {
        path: '/calculator',
        name: 'calculator',
        component: () => import('/src/views/calculator/Calculator.vue'),
        meta: {
            showFooter: false,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            blankLayout: true,
            seo: {
                title: "Sovi.AI Solver - Interactive Math & LaTeX Calculator",
                description: "Solve complex algebra, calculus, and statistics step-by-step with Sovi.AI's advanced MathLive calculator. Real-time 2D graphing and AI explanations."
            }
        }
    },
    {
        path: '/',
        name: 'home',
        component: () => import('/src/views/home/landing/Home.vue'),
        meta: {
            showFooter: false,
            showUser: true,
            showMenu: false,
            requireAuth: false,
            showSmallScreenHeader: false,
            seo: {
                title: "Sovi.AI - AI Study Companion for Homework & AP Test Prep",
                description: "Sovi.AI is an AI-powered study companion for all subjects. Get homework help with clear explanations, chat with PDFs, generate quizzes, and practice AP exams."
            }
        }
    },
    {
        path: '/home',
        name: 'user-home',
        component: () => import('/src/views/home/HomeNew.vue'),
        meta: {
            showFooter: false,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "Home - Your AI Study Space | Sovi.AI",
                description: "Welcome to your personal AI study space. Choose a study mode, upload homework images or PDFs, and study smarter with Sovi.AI."
            }
        }
    },
    {
        path: '/study',
        name: 'study',
        component: () => import('/src/views/study/Study.vue'),
        meta: {
            seoContent: 'study',
            showFooter: false,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "AI Study Tools - Chat PDF & File Summariser | Sovi.AI",
                description: "Upload your study materials and let Sovi.AI build knowledge maps, chat with PDFs, and generate practice quizzes to boost your learning."
            }
        }
    },
    {
        path: '/studygroup/:code?',
        name: 'study-group',
        component: () => import('/src/views/study/StudyGroup.vue'),
        meta: {
            showFooter: false,
            showUser: true,
            showMenu: false,
            requireAuth: false,
            showSmallScreenHeader: false,
            seo: {
                title: "Join Study Group | Sovi.AI",
                description: "You have been invited to join a study group on Sovi.AI. Join the group and study smarter together!"
            }
        }
    },
    {
        path: '/study/detail/:id',
        name: 'study-detail',
        component: () => import('/src/views/study/StudyDetail.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: true
        }
    },
    {
        path: '/study/quiz/:id',
        name: 'study-quiz',
        component: () => import('/src/views/study/StudyQuiz.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: true
        }
    },
    {
        path: '/study/quiz-view/:quizId',
        name: 'study-quiz-view',
        component: () => import('/src/views/study/StudyQuizView.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: true
        }
    },
    {
        path: '/study/result/:id',
        name: 'study-result',
        component: () => import('/src/views/study/StudyResult.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: true
        }
    },
    {
        path: '/chat',
        name: 'chat',
        component: () => import('/src/views/chat/Chat.vue'),
        meta: {
            seoContent: 'chat',
            showUser: true,
            showMenu: true,
            showSmallScreenHeader: true,
            requireAuth: false,
            seo: {
                title: "Ask Sovi - AI Homework Helper | Sovi.AI",
                description: "Get instant AI-powered homework help with accurate step-by-step solutions across all subjects. Ask questions via text or image with Ask Sovi."
            }
        }
    },
    {
        path: '/video',
        name: 'video',
        component: () => import('/src/views/video/Video.vue'),
        meta: {
            showUser: true,
            showMenu: true,
            showSmallScreenHeader: true,
            requireAuth: false,
            seo: {
                title: "AI Tutorial Videos | Sovi.AI",
                description: "Watch step-by-step AI tutorial videos to help you study smarter and ace your exams with Sovi.AI."
            }
        }
    },
    {
        path: '/pay/app',
        name: 'pay-app-landing',
        component: () => import('/src/views/pay/AppPayLanding.vue'),
        meta: {
            showFooter: true,
            showUser: false,
            showMenu: false,
            requireAuth: false,
            showSmallScreenHeader: false,
            payLandingSmallHeader: true
        }
    },
    {
        path: '/pinterest',
        name: 'pinterest',
        component: () => import('/src/views/pinterest/PinterestLanding.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: false,
            requireAuth: false,
            showSmallScreenHeader: false,
            seo: {
                title: "Sovi's Card Gallery - Study Smarter with AI Flashcards | Sovi.AI",
                description: "Explore Sovi's Card Gallery featuring high-quality Concept Cards, Memorizer Cards, and Application Cards. Master Math, Physics, Biology, and Chemistry smarter with Sovi.AI's AI-powered study buddy!"
            }
        }
    },
    {
        path: '/svip',
        name: 'svip',
        component: () => import('/src/views/svip/Svipplan.vue'),
        meta: {
            showFooter: false,
            showUser: true,
            showMenu: true,
            requireAuth: true,
            showSmallScreenHeader: true
        }
    },
    {
        path: '/history',
        name: 'history',
        component: () => import('/src/views/history/History.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: true
        }
    },
    {
        path: '/history/testprep',
        name: 'testprep-history',
        component: () => import('/src/views/history/TestPrepHistory.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: true
        }
    },
    {
        path: '/app',
        name: 'app',
        component: () => import('/src/views/About.vue'),
        meta: {
            seoContent: 'app',
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "Download Sovi.AI App | Sovi.AI",
                description: "Download the Sovi.AI iOS app and study smarter on the go. Get AI homework help, Chat PDF, File Summariser, and AP Test Prep in your pocket."
            }
        }
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: true,
            showSmallScreenHeader: true
        },
        component: () => import('/src/views/profile/Profile.vue')
    },
    {
        path: '/submitfeedback',
        name: 'submitfeedback',
        component: () => import('/src/views/feedback/SubmitFeedback.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "Submit Feedback | Sovi.AI",
                description: "Submit feedback to Sovi.AI to help us improve our service."
            }
        }
    },

    {
        path: '/faq/:categoryId/:itemId',
        name: 'faq-detail',
        component: () => import('/src/views/feedback/FaqDetail.vue'),
        meta: {
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true
        }
    },
    {
        path: '/message',
        name: 'message',
        component: () => import('/src/views/message/Message.vue'),
        meta: {
            showUser: true,
            showMenu: true,
            requireAuth: true,
            showSmallScreenHeader: true
        }
    },
    {
        path: '/message/:id',
        name: 'message-detail',
        component: () => import('/src/views/message/MessageDetail.vue'),
        meta: {
            showUser: true,
            showMenu: true,
            requireAuth: true,
            showSmallScreenHeader: true
        }
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: () => import('/src/views/feedback/Feedback.vue'),
        meta: {
            showUser: true,
            showMenu: true,
            requireAuth: true,
            showSmallScreenHeader: true
        }
    },
    {
        path: '/apexam',
        name: 'apexam',
        component: () => import('/src/views/apexam/index.vue'),
        meta: {
            seoContent: 'apexam',
            showFooter: false,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "AP Test Prep - Practice AP Exams Online | Sovi.AI",
                description: "Practice AP exams with full mock tests and unit-level practice across multiple AP subjects. Simulate real exam conditions with Sovi.AI."
            }
        }
    },
    {
        path: '/apexam/practice',
        name: 'apexam-practice',
        component: () => import('/src/views/apexam/practice.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: false
        }
    },
    {
        path: '/apexam/exam-info',
        name: 'apexam-exam-info',
        component: () => import('/src/views/apexam/exam-info.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: false
        }
    },
    {
        path: '/apexam/exam',
        name: 'apexam-exam',
        component: () => import('/src/views/apexam/exam.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: false
        }
    },
    {
        path: '/apexam/result',
        name: 'apexam-result',
        component: () => import('/src/views/apexam/result.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: true
        }
    },
    {
        path: '/blog',
        redirect: '/blog/basic-knowledge/1'
    },
    {
        path: '/blog/:category',
        redirect: to => `/blog/${to.params.category}/1`
    },
    {
        path: '/blog/:category/:pageOrSlug',
        name: 'blog',
        component: () => import('/src/views/blog/BlogResolver.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "Blog - Study Tips & Learning Guides | Sovi.AI",
                description: "Explore study tips, grammar guides, learning strategies, and educational insights on the Sovi.AI blog."
            }
        }
    },
    {
        path: '/expert',
        component: () => import('/src/views/expert/ExpertLayout.vue'),
        meta: {
            showFooter: false,
            showUser: false,
            showMenu: false,
            requireAuth: false,
            showSmallScreenHeader: false,
            seo: {
                title: "Ask an Expert - 24/7 Homework Help | Sovi.AI",
                description: "Connect with expert tutors for 24/7 step-by-step homework help across all subjects on Sovi.AI."
            }
        },
        children: [
            {
                path: '',
                name: 'expert',
                component: () => import('/src/views/expert/ExpertHelp.vue')
            },
            {
                path: 'answer',
                name: 'expert-answer',
                component: () => import('/src/views/expert/ExpertAnswer.vue')
            }
        ]
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('/src/views/search/Search.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true
        }
    },
    {
        path: '/resources',
        redirect: '/resources/category/math/1'
    },
    {
        path: '/resources/category/math',
        redirect: '/resources/category/math/1'
    },
    {
        path: '/resources/category/:subject/:page',
        name: 'resourceCategory',
        component: () => import('/src/views/questions/Questions.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "Question Bank - Sovi.AI",
                description: "Explore question bank by subject and keyword."
            }
        }
    },
    {
        path: '/resources/:subject/:slug',
        name: 'resourceQuestionDetail',
        component: () => import('/src/views/questions/QuestionDetail.vue'),
        meta: {
            showFooter: true,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "Question Detail - Sovi.AI",
                description: "Explore question detail by subject and slug."
            }
        }
    },
    
    {
        path: '/resources/:pathMatch(.*)*',
        name: 'resource',
        component: () => import('/src/views/resource/Resource.vue'),
        meta: {
            showFooter: false,
            showUser: true,
            showMenu: true,
            requireAuth: false,
            showSmallScreenHeader: true,
            seo: {
                title: "Study Resources by Subject | Sovi.AI",
                description: "Browse a comprehensive library of study resources organized by subject — Math, Science, Humanities, Business, and more."
            }
        }
    }
]

// Singleton router reference — set by ViteSSG in main.ts, consumed by non-component code.

const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_APP_ROUTE_BASE),
    routes
})

let _router = router
export function setRouter(r) { _router = r }
export function getRouter() { return _router }
export default router


/**
 * Register dynamic iframe routes from menu data.
 */
export function registerIframeRoutes(router: Router, iframeMenus: Array<{ id: number; path: string; externalUrl: string; requireAuth: boolean }>) {
    const IframeView = () => import('@/views/iframe/IframeView.vue')
    for (const menu of iframeMenus) {
        if (router.hasRoute(`iframe-${menu.id}`)) {
            continue
        }
        router.addRoute({
            path: menu.path,
            name: `iframe-${menu.id}`,
            component: IframeView,
            meta: {
                showMenu: true,
                showFooter: false,
                iframeUrl: menu.externalUrl,
                requireAuth: menu.requireAuth
            }
        })
    }
}
